<div class="edit-payment-date-dialog">
  <header class="dialog-header">
    <div class="dialog-header__icon" aria-hidden="true">
      <mat-icon>event</mat-icon>
    </div>
    <div class="dialog-header__text">
      <h2 mat-dialog-title>Fecha de pago programada</h2>
      <p class="dialog-header__context">OS N° {{ data.service?.order?.displayCode || data.service?.order?.orderNumber || '—' }}</p>
    </div>
  </header>

  <ng-container *ngIf="state === 'form'">
    <mat-dialog-content class="dialog-body">
      <div *ngIf="!canEdit" class="alert alert--error">
        <mat-icon>block</mat-icon>
        <span>{{ blockedMessage }}</span>
      </div>

      <div class="co-field-group">
        <div class="co-field-group__header">
          <label class="co-field-group__label" for="edit-scheduledPaymentDate">
            Nueva fecha
          </label>
          <span class="co-field-badge co-field-badge--required">Obligatorio</span>
        </div>
        <div class="co-date-field" [class.co-date-field--disabled]="!canEdit">
          <input
            id="edit-scheduledPaymentDate"
            class="co-date-field__input"
            matInput
            [matDatepicker]="fechaPagoProgramadaPicker"
            [formControl]="fechaPagoProgramadaInput"
            placeholder="DD/MM/AAAA"
            autocomplete="off"
          />
          <mat-datepicker-toggle
            class="co-date-field__toggle"
            [for]="fechaPagoProgramadaPicker"
            [disabled]="!canEdit"
          ></mat-datepicker-toggle>
          <mat-datepicker #fechaPagoProgramadaPicker></mat-datepicker>
        </div>
        <p class="co-field-group__hint">
          Formato DD/MM/AAAA. Debes indicar una fecha válida para guardar.
        </p>
        <p
          *ngIf="fechaPagoProgramadaInput.touched && fechaPagoProgramadaInput.invalid"
          class="co-field-group__error"
        >
          Ingresa una fecha válida.
        </p>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-stroked-button type="button" class="co-btn co-btn--ghost" (click)="onCancel()">
        Cancelar
      </button>
      <button
        mat-flat-button
        type="button"
        class="co-btn co-btn--primary"
        [disabled]="!canEdit || fechaPagoProgramadaInput.invalid || isLoading"
        (click)="updateFechaPagoProgramada()"
      >
        <mat-spinner *ngIf="isLoading" [diameter]="18"></mat-spinner>
        <span *ngIf="!isLoading">Guardar</span>
      </button>
    </mat-dialog-actions>
  </ng-container>

  <ng-container *ngIf="state === 'error'">
    <mat-dialog-content class="dialog-body">
      <div class="alert alert--error">
        <mat-icon>error_outline</mat-icon>
        <div>
          <strong *ngIf="errorTitle">{{ errorTitle }}</strong>
          <span>{{ errorMessage }}</span>
        </div>
      </div>
      <p class="co-field-group__hint">
        La grilla puede estar desactualizada. Al continuar se consultará de nuevo el backend.
      </p>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button
        mat-flat-button
        type="button"
        class="co-btn co-btn--primary"
        (click)="cerrarYActualizar()"
      >
        Entendido y actualizar
      </button>
    </mat-dialog-actions>
  </ng-container>
</div>
